import UploadAdapter from "./UploadAdapter";

/**
 * Our domain-specific adapter
 * @param {object} opts
 * @param {string} opts.serverErrorMessage - default error message used when server sends { ok: 0 }
 * @constructor
 * @extends UploadAdapter
 */
const BasicAdapter = UploadAdapter.extend({
  getUploadPath() {
    const { base, upload } = this.opts.url;
    return base + upload;
  },

  getDeletePath(model) {
    if(model.sid === undefined) return null; // shouldn't happen
    const { base, delete: del } = this.opts.url;
    return base + del.replace(/##id##/g, model.sid);
  },

  getSortPath(models) {
    const { base, sort } = this.opts.url;
    return base + sort.replace(/##ids##/g, models.map(m => m.sid).filter(i => i !== undefined).join(","));
  },

  /**
   * Get url for rotateImage action
   * @param {ImageModel} model
   * @param {number} angle     - rotation angle in degrees
   * @returns {string|null}
   * @protected
   */
  getRotatePath(model, angle) {
    if(model.sid === undefined) return null; // shouldn't happen
    const { base, rotate } = this.opts.url;
    return (base + rotate.replace(/##id##/g, model.sid).replace(/##angle##/g, angle.toFixed(0)));
  },

  getPayload(str) {
    return JSON.parse(str);
  },

  validatePayload({ok}) {
    // TODO: get message from server eventually
    if(!ok) return this.opts.serverErrorMessage;
    return 0;
  },

  /**
   * Action for rotating an image
   * @param {ImageModel} model
   * @param {boolean} isRight - whether to rotate right - clockwise
   * @param {function} cb     - (error, result) callback
   */
  rotateImage(model, isRight, cb) {
    const rotatePath = this.getRotatePath(model, isRight ? 270 : 90);

    if(rotatePath === null) {
      cb({ message: "Can't create rotation url for image" });
      return;
    }

    this.enqueue("rotate", {
      url: rotatePath,
      method: "GET",
      cb
    });
  }
});

export default BasicAdapter;

// Act=resort&resort=id1,id2